const AddressLink = "http://147.47.125.118:6006";
//const AddressLink = "http://127.0.0.1:8000";
export {AddressLink};
